const quillToolbar = [
    ['clean'],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' },
    { 'indent': '-1' }, { 'indent': '+1' }],
    ['link'],
];

export default {
    theme: 'snow',
    modules: {
        toolbar: quillToolbar,
    },
};
